<template>
  <div>
    <h4>Contacts</h4>
  <div class="jumbotron">
    <div class="row">
      <h4>Administrator</h4>
    </div>
    <div class="row">
      <div class="col-md-3 text-right my-auto">
        <p class="no-margin-bottom">First Name<span class="red-text" v-if="!getAdminFirstName">*</span></p>
      </div>
      <div class="col-md-9 my-auto">
        <input v-model="adminFirstName"
               class="form-control form-control-md"
               v-bind:class="{'is-invalid': adminFirstNameInvalid}">
        <div class="invalid-feedback">
          Please enter your adminstrator's first name
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3 text-right my-auto">
        <p class="no-margin-bottom">Last Name<span class="red-text" v-if="!getAdminLastName">*</span></p>
      </div>
      <div class="col-md-9 my-auto">
        <input v-model="adminLastName"
               class="form-control form-control-md"
               v-bind:class="{'is-invalid': adminLastNameInvalid}">
        <div class="invalid-feedback">
          Please enter your adminstrator's last name
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3 text-right my-auto">
        <p class="no-margin-bottom">Email<span class="red-text" v-if="!getAdminEmail">*</span></p>
      </div>
      <div class="col-md-9 my-auto">
        <input v-model="adminEmail"
               class="form-control form-control-md"
               v-bind:class="{'is-invalid': adminEmailInvalid}">
        <div class="invalid-feedback">
          Please enter your adminstrator's email
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3 text-right my-auto">
        <p class="no-margin-bottom">Phone Number<span class="red-text" v-if="!getAdminPhone">*</span></p>
      </div>
      <div class="col-md-9 my-auto">
        <vue-tel-input v-model="adminPhone"
                       :disabledFetchingCountry="true"
                       class="form-control form-control-md phone-number"
                       v-bind:class="{'is-invalid': adminPhoneNumberInvalid, 'border-red': adminPhoneNumberInvalid}"
                       :onlyCountries="['us']">
        </vue-tel-input>
        <div class="invalid-feedback">
          Please enter your adminstrator's phone number
        </div>
      </div>
    </div>

    <div v-if="hasBilling">
    <div class="row">
      <h4>Billing</h4>
    </div>
    <div class="row">
      <div class="col-md-3 text-right my-auto">
        <p class="no-margin-bottom">First Name</p>
      </div>
      <div class="col-md-9 my-auto">
        <input v-model="qcFirstName"
               class="form-control form-control-md"
               v-bind:class="{'is-invalid': qcFirstNameInvalid}">
        <div class="invalid-feedback">
          Please enter your billing contact's first name
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3 text-right my-auto">
        <p class="no-margin-bottom">Last Name</p>
      </div>
      <div class="col-md-9 my-auto">
        <input v-model="qcLastName"
               class="form-control form-control-md"
               v-bind:class="{'is-invalid': qcLastNameInvalid}">
        <div class="invalid-feedback">
          Please enter your billing contact's last name
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3 text-right my-auto">
        <p class="no-margin-bottom">Email</p>
      </div>
      <div class="col-md-9 my-auto">
        <input v-model="qcEmail"
               class="form-control form-control-md"
               v-bind:class="{'is-invalid': qcEmailInvalid}">
        <div class="invalid-feedback">
          Please enter your billing contact's email
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3 text-right my-auto">
        <p class="no-margin-bottom">Phone Number</p>
      </div>
      <div class="col-md-9 my-auto">
        <vue-tel-input v-model="qcPhone"
                       :disabledFetchingCountry="true"
                       class="form-control form-control-md phone-number"
                       v-bind:class="{'is-invalid': qcPhoneNumberInvalid, 'border-red': qcPhoneNumberInvalid}"
                       :onlyCountries="['us']">
        </vue-tel-input>
        <div class="invalid-feedback">
          Please enter your billing contact's phone number
        </div>
      </div>
    </div>
    </div>

    <div v-if="hasCustomerService">
    <div class="row">
      <h4>Customer Service</h4>
    </div>
    <div class="row">
      <div class="col-md-3 text-right my-auto">
        <p class="no-margin-bottom">First Name</p>
      </div>
      <div class="col-md-9 my-auto">
        <input v-model="csFirstName"
               class="form-control form-control-md"
               v-bind:class="{'is-invalid': csFirstNameInvalid}">
        <div class="invalid-feedback">
          Please enter your customer service representative's first name
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3 text-right my-auto">
        <p class="no-margin-bottom">Last Name</p>
      </div>
      <div class="col-md-9 my-auto">
        <input v-model="csLastName"
               class="form-control form-control-md"
               v-bind:class="{'is-invalid': csLastNameInvalid}">
        <div class="invalid-feedback">
          Please enter your customer service representative's last name
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3 text-right my-auto">
        <p class="no-margin-bottom">Email</p>
      </div>
      <div class="col-md-9 my-auto">
        <input v-model="csEmail"
               class="form-control form-control-md"
               v-bind:class="{'is-invalid': csEmailInvalid}">
        <div class="invalid-feedback">
          Please enter your customer service representative's email
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3 text-right my-auto">
        <p class="no-margin-bottom">Phone Number</p>
      </div>
      <div class="col-md-9 my-auto">
        <vue-tel-input v-model="csPhone"
                       :disabledFetchingCountry="true"
                       class="form-control form-control-md phone-number"
                       v-bind:class="{'is-invalid': csPhoneNumberInvalid, 'border-red': csPhoneNumberInvalid}"
                       :onlyCountries="['us']">
        </vue-tel-input>
        <div class="invalid-feedback">
          Please enter your customer service representative's phone number
        </div>
      </div>
    </div>
    </div>

    <div class="row">
      <div class="col">
        <button v-on:click="billing = true" v-if="hasBilling === false" class="btn btn-primary">Billing Contact</button>
      </div>
      <div class="col">
        <button v-on:click="customer = true" v-if="hasCustomerService === false" class="btn btn-primary">Customer Service</button>
      </div>
    </div>
    <div class="row">
      <div class="col-md-8 offset-md-2">
        <button v-if="complete" v-on:click="save" class="btn btn-primary">Save</button>
        <button v-else v-on:click="save" class="btn btn-primary">Save & Continue</button>
      </div>
    </div>
    <div class="row">
      <div class="col-md-10 offset-md-1">
        <b-alert variant="success"
             dismissible
             :show="showDismissibleAlert"
             @dismissed="showDismissibleAlert=false">
          Data Saved
        </b-alert>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import VueTelInput from 'vue-tel-input'
import 'vue-tel-input/dist/vue-tel-input.css'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import router from '../../../../router/index.js'

export default {
  created () {
    this.complete = this.profileIsComplete.profileComplete
  },
  data () {
    return {
      adminFirstNameInvalid: false,
      adminLastNameInvalid: false,
      adminEmailInvalid: false,
      adminPhoneNumberInvalid: false,
      complete: false,
      qcFirstNameInvalid: false,
      qcLastNameInvalid: false,
      qcEmailInvalid: false,
      qcPhoneNumberInvalid: false,
      csFirstNameInvalid: false,
      csLastNameInvalid: false,
      csEmailInvalid: false,
      csPhoneNumberInvalid: false,
      formInvalid: false,
      billing: false,
      customer: false,
      showDismissibleAlert: false
    }
  },
  components: {
    VueTelInput
  },
  methods: {
    ...mapActions('business', [
      'syncData'
    ]),
    ...mapMutations('business', [
      'updateAdminFirstName',
      'updateAdminLastName',
      'updateAdminEmail',
      'updateAdminPhone',
      'updateQcFirstName',
      'updateQcLastName',
      'updateQcEmail',
      'updateQcPhone',
      'updateCsFirstName',
      'updateCsLastName',
      'updateCsEmail',
      'updateCsPhone'
    ]),
    async save () {
      this.validate()
      if (this.formInvalid === false) {
        this.syncData()
        this.showDismissibleAlert = true
        if (!this.complete) {
          router.replace('/profile/business/dashboard')
        }
      }
    },
    validate () {
      this.formInvalid = false

      if (!this.getAdminFirstName) {
        this.adminFirstNameInvalid = true
        this.formInvalid = true
      } else {
        this.adminFirstNameInvalid = false
      }

      if (!this.getAdminLastName) {
        this.adminLastNameInvalid = true
        this.formInvalid = true
      } else {
        this.adminLastNameInvalid = false
      }

      var adminPhoneRegex = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/
      if (!adminPhoneRegex.test(this.getAdminPhone)) {
        this.adminPhoneNumberInvalid = true
        this.formInvalid = true
      } else {
        this.adminPhoneNumberInvalid = false
      }

      var adminEmailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      if (!adminEmailRegex.test(this.getAdminEmail)) {
        this.adminEmailInvalid = true
        this.formInvalid = true
      } else {
        this.adminEmailInvalid = false
      }
    }
  },
  computed: {
    ...mapGetters('business', [
      'getAdminFirstName',
      'getAdminLastName',
      'getAdminEmail',
      'getAdminPhone',
      'getQcFirstName',
      'getQcLastName',
      'getQcEmail',
      'getQcPhone',
      'getCsFirstName',
      'getCsLastName',
      'getCsEmail',
      'getCsPhone',
      'profileIsComplete'
    ]),
    hasBilling () {
      if (this.getQcFirstName || this.getQcLastName || this.getQcEmail || this.getQcPhone || this.billing) {
        return true
      } else {
        return false
      }
    },
    hasCustomerService () {
      if (this.getCsFirstName || this.getCsLastName || this.getCsEmail || this.getCsPhone || this.customer) {
        return true
      } else {
        return false
      }
    },
    adminFirstName: {
      get () {
        return this.getAdminFirstName
      },
      set (value) {
        this.updateAdminFirstName(value)
      }
    },
    adminLastName: {
      get () {
        return this.getAdminLastName
      },
      set (value) {
        this.updateAdminLastName(value)
      }
    },
    adminEmail: {
      get () {
        return this.getAdminEmail
      },
      set (value) {
        this.updateAdminEmail(value)
      }
    },
    adminPhone: {
      get () {
        return this.getAdminPhone
      },
      set (value) {
        this.updateAdminPhone(value)
      }
    },

    qcFirstName: {
      get () {
        return this.getQcFirstName
      },
      set (value) {
        this.updateQcFirstName(value)
      }
    },
    qcLastName: {
      get () {
        return this.getQcLastName
      },
      set (value) {
        this.updateQcLastName(value)
      }
    },
    qcEmail: {
      get () {
        return this.getQcEmail
      },
      set (value) {
        this.updateQcEmail(value)
      }
    },
    qcPhone: {
      get () {
        return this.getQcPhone
      },
      set (value) {
        this.updateQcPhone(value)
      }
    },

    csFirstName: {
      get () {
        return this.getCsFirstName
      },
      set (value) {
        this.updateCsFirstName(value)
      }
    },
    csLastName: {
      get () {
        return this.getCsLastName
      },
      set (value) {
        this.updateCsLastName(value)
      }
    },
    csEmail: {
      get () {
        return this.getCsEmail
      },
      set (value) {
        this.updateCsEmail(value)
      }
    },
    csPhone: {
      get () {
        return this.getCsPhone
      },
      set (value) {
        this.updateCsPhone(value)
      }
    }
  }
}
</script>

<style scoped>
.phone-number >>> input {
  color: #495057;
}

.border-red {
  border-color: red;
}

.border-red:focus-within {
  border-color: #dc3545;
  box-shadow: 0 0 0 .2rem rgba(220,53,69,.25);
}

.jumbotron {
  background-color: #f1f1f1 !important;
  margin-bottom: 3rem !important;
  border-radius: 25px;
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.no-margin-bottom {
  margin-bottom: 0px;
}

.row {
  margin-bottom: 1rem;
}

.red-text {
  color: red;
}

@media (max-width: 768px) {
  .text-right {
    text-align: left !important;
    padding-left: 1rem;
  }
}

.needs-margin-right {
  margin-left: .75rem;
}
</style>



// WEBPACK FOOTER //
// src/components/profile/businessProfile/contacts/HomaptContacts.vue